import * as RT from "@radix-ui/react-tooltip";
import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

// Wrap the app once in TooltipProvider (Phase 5 app shell).
export const TooltipProvider = RT.Provider;

export interface TooltipProps {
  content: ReactNode;
  children: ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  delayDuration?: number;
  className?: string;
}

export function Tooltip({ content, children, side = "top", delayDuration = 200, className }: TooltipProps) {
  if (content == null || content === "") return <>{children}</>;
  return (
    <RT.Root delayDuration={delayDuration}>
      <RT.Trigger asChild>{children}</RT.Trigger>
      <RT.Portal>
        <RT.Content
          side={side}
          sideOffset={6}
          className={cn(
            "z-50 max-w-xs rounded-lg bg-surface-3 px-2.5 py-1.5 text-xs font-medium text-fg shadow-elevated",
            "data-[state=delayed-open]:animate-fade-in",
            className,
          )}
        >
          {content}
          <RT.Arrow className="fill-surface-3" />
        </RT.Content>
      </RT.Portal>
    </RT.Root>
  );
}
